const wavePickingRouter = [
  {
    path: "wavepicking/mallshippingarea", // 地区可用快递设置
    name: "mallshippingarea",
    component: () => import("../pages/wavepicking/mallshippingarea"),
    meta: {
      title: "地区可用快递设置",
    },
  },
  {
    path: "wavepicking/mallshippingopen", // 商城可选快递开放列表
    name: "mallshippingopen",
    component: () => import("../pages/wavepicking/mallshippingopen"),
    meta: {
      title: "用户可选快递设置",
    },
  },
  {
    path: "setting/upshelf", // 上架设置
    name: "settingUpshelf",
    component: () => import("../pages/setting/upshelf"),
    meta: {
      title: "上架设置",
    },
  },
  {
    path: "wavepicking/outTransfer", // 上架设置
    name: "outTransfer",
    component: () => import("../pages/wavepicking/OutTransfer"),
    meta: {
      title: "外协发货",
    },
  },
];

export default wavePickingRouter;



// WEBPACK FOOTER //
// ./src/router/wavePicking.js